// extracted by mini-css-extract-plugin
export default {"searchArea":"OrgOuTree_searchArea__1vX22","treeArea":"OrgOuTree_treeArea__2FKPL","treeBox":"OrgOuTree_treeBox__r2WqO"};